import React from "react";

import "../styles/layout.css";
import Layout from "./layout";

export default function CustomLayout({ element, props }, pluginOptions) {
  return <Layout {...props}>{element}</Layout>;
}
